// A bare country-code stub (e.g. "+30" or "357") with no actual number.
export function isPhoneNumberStub(value: string): boolean {
  return /^\+?\d{1,4}$/.test(value);
}
